import React, { useState} from "react";
import { useLocation } from 'react-router-dom';
import { UserPlus, Mail, Phone, AlertTriangle } from "lucide-react";
import { UpdateUserRoleByAdmin, UserByMail, isAuthenticated, getUserAddingRoleToken } from "../auth";
import { buildUserChoosingUrl } from "../../utils/userAddingRoleToken";
import PhoneInput, { parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber, getCountryCallingCode  } from 'react-phone-number-input'
import ElakayAccount from '../Layout/imgs/Elakay-account-1.png';
import RoyaltyUser from '../Layout/imgs/Royalty-user-1.png';
import SellerPub1 from '../Layout/imgs/Seller-pub-1.png';
import jsSHA from "jssha";
import { roleUser } from "../pageInside/roleUser";
import { Family, Adminstrator, Investment, Assoociate} from "../pageInside/Rolle"
import ShareButton from "../pageInside/ShareButton";
import SuccessResultCard from "../pageInside/SuccessResultCard";
import {ELAKAY_URl, ELAKAY_URl1, elakay_API, toElakaySiteUrl} from "../../config";
import Timer from "../pageInside/timer";
import AdminSlotTable from "../pageInside/adminSlotTable";
import { getShareMessageByLang } from "../pageInside/shareMessageTranslations";
import "./adminPages.css";
import "./InvitationForm.css";
import { tokenText } from "./roleTokens/tokenText";

// import required modules
// import { Autoplay, Pagination, Navigation } from "swiper";
import en from 'react-phone-number-input/locale/en.json'
import 'react-phone-number-input/style.css'
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const D = {
  blue: "var(--elakay-primary,#007399)", blueLt: "#e5f3f7",
  green: "#10b981", greenLt: "#d1fae5",
  amber: "#f59e0b", amberLt: "#fef3c7",
  red: "#ef4444", redLt: "#fee2e2",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "var(--font-system,system-ui)",
};

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addAdminFamily"]?.[key] || fallback;

var sha1 = require('sha1');

function useQuery() {
    return new URLSearchParams(useLocation().search);
}



const Message = (props) => {
    const {
        infoSource,
        usel = 0,
        selectRole,
        setSelectRole,
        userTeam
            } = props

    __setElakayInfoSource(infoSource);
    const tt = tokenText(infoSource);
    let query = useQuery();
    // let usel  = query.get("usel") ? query.get("usel") : 0


    const [loading, setLoading] = useState(false);

    // const [userInfo, setUserInfo] = useState([]);
    const { token } = isAuthenticated();

    let ilcod = infoSource.languageAPI.checkLangObjDefault
    let ileia =  infoSource.languageAPI.elakayInfoAPI
    let ilei = infoSource.languageAPI.elakayInfo

    let InfoApiLabel =  !infoSource.loading && ilcod(ileia, ilei, 'label')
    let InfoApiMenuSertting =  !infoSource.loading && ilcod(ileia, ilei, 'menuSertting')
    let InfoApiText = !infoSource.loading && ilcod(ileia, ilei, 'text')
    let InfoApiButton = !infoSource.loading && ilcod(ileia, ilei, 'Button')

    let Rele_user
    let objUserRole = {
        userID: '',
        firstname: '',
        lastname: '',
        email: '',
        customer: '',
        seller: '',
        provider: '',
        password: '',
        userRole:'',
        error: '',
        message: '',
        linkAdmin: '',
        class_ErrName: 'alert alert-danger',
        success: '',
        maxRoyalite: '',
        maxSeller: '',
        maxProducer: '',
        maxAssociate: '',
        maxInvestment: '',
        maxAdmin: '',
        nbrDays: 0,
        passwordShow: false,
        emailExit: false
    }
    const [telPhone, setTelPhone] = useState()
    // const [selectRole, setSelectRole] = useState(Number(usel));
    const [emailUser, setEmailUser] = useState('')
    const [emailvsTelAdding, setEmailvsTelAdding] = useState(true);
    const [Urole, setURole] = useState(objUserRole);
    const [nbrTimer, setNbrTimer] = useState(0);
    const [tokenua, setTokenua] = useState(true);
    const [shareUrl, setShareUrl] = useState()
    const [showAlert, setShowAlert] = useState(null);

    // Result of the final "add/assign role" submission (clickPassword) --
    // single source of truth (mission 13), never rebuilt from several older
    // variables that can desync. idle | submitting | success | error.
    const [operationStatus, setOperationStatus] = useState("idle");
    const [operationResult, setOperationResult] = useState(null);
    const [activationUrl, setActivationUrl] = useState("");

    // "Finish": closes the result, resets the form, and only then allows a
    // new submission (mission 12: never close/clear before the admin has had
    // a chance to share/copy/show the QR code).
    const handleFinishOperation = () => {
        setOperationStatus("idle")
        setOperationResult(null)
        setActivationUrl("")
        setSelectRole(0)
        setEmailUser('')
        setTelPhone()
        setURole(objUserRole)
    }

    const triggerAlert = (n, e) => {
        setShowAlert(`Sorry, you have entered a value greater than the maximum allowed, which is ${n}. The maximum value has been set by default.`);
        setShowAlert(`Sorry, you entered ${e}, which exceeds the maximum allowed value of ${n}. The maximum value will be displayed by default.`)
        setTimeout(() => setShowAlert(null), 10000);
      };
      
    let editroleuser

    const {
        userID,
        firstname,
        lastname,
        email,
        customer,
        seller,
        provider,
        password,
        userRole,
        error,
        message,
        class_ErrName,
        success,
        maxRoyalite,
        maxSeller,
        maxProducer,
        maxAssociate,
        maxAdmin,
        maxInvestment,
        nbrDays,
        passwordShow,
        emailExit,
        linkAdmin
    } = Urole
                    // signupUPdateRole({email: data.email,  userInfoRole:{role: role(roleUser, data._id, 5), roleName:''}}, pubToken
    const roleSha1 = (roleUser, userID, index) => {
        if (!roleUser || !roleUser[index] || !roleUser[index].code || !roleUser[index].role || !userID) {
            throw new Error("Invalid input data");
        }

        // Fonction pour générer un SHA-1
        const sha1 = (data) => crypto.createHash("sha1").update(data).digest("hex");

        // Générer "kay" en combinant les hash SHA-1
        let kay = sha1(roleUser[index].code) + sha1(roleUser[index].role) + sha1(userID);

        // Créer un HMAC SHA-512 avec "kay" comme clé
        const shaObj = crypto.createHmac("sha512", kay);
        shaObj.update(kay);

        return shaObj.digest("hex"); // Retourne le hash SHA-512 en hexadécimal
    };

    const handleChange = () => event => {
        const value = event.target.value;
        setSelectRole(Number(value));
        setShareUrl('')
        setURole(objUserRole)
    };

    const handlePassword = name => event => {
        const value = event.target.value;
        setURole({ ...Urole, [name]: value });
        if(name==='linkAdmin'){
           let urlEl = ELAKAY_URl
           let urlOK = linkAdmin.includes(urlEl)
        }
    };

    const handleChangeNumber = name => event => {
        // const value = event.target.value;
        const maxNumber = infoSource.userInfo.userActiveRole[name]
        const inputValue = event.target.value;
        // Vérifie si la valeur est un nombre valide
        if (!isNaN(inputValue) && inputValue !== '') {
            const numericValue = Number(inputValue);

            // Applique la limite maximale si définie
           if(Family()){
            setURole({ ...Urole, [name]: numericValue });
           } else if (numericValue > maxNumber) {
                setURole({ ...Urole, [name]: maxNumber }); // Force la valeur maximale
                 triggerAlert(maxNumber, numericValue);
            } else {

                setURole({ ...Urole, [name]: numericValue });
            }
        } else if (inputValue === '') {
            setURole({ ...Urole, [name]: "" }); // Permet d'effacer l'entrée
        }

    };

    const handleEmail = () => event => {
        const value = event.target.value;
        setEmailUser(value);
    };

var betterRole = (role, sel)=>{
    let y = true
    let x = false
    let _a = role === 'User' &&  1
    let a = role === 'Royalty' &&  1
    let b = role === 'Seller'  && 2
    let c = role === 'Provider'  && 3
    let d = role === 'Associate' && 4
    let e = role === 'Investment' && 5
    let f = role === 'Administrator' && 6
    let g = role ==='Family' && 7

    let z = _a || a || b || c || d || e || f || g
   if (Number(sel) >= Number(z)) {
    return y
   }else {
    return x
   }
}
var editRole = (role, sel)=>{
    let y = true
    let x = false
    let _a = role === 'User' &&  0
    let a = role === 'Royalty' &&  1
    let b = role === 'Seller'  && 2
    let c = role === 'Provider'  && 3
    let d = role === 'Associate' && 4
    let e = role === 'Investment' && 5
    let f = role === 'Administrator' && 6
    let g = role ==='Family' && 7

    let z = _a || a || b || c || d || e || f || g

   if (Number(sel) === Number(z)) {
    return y
   }else {
    return x
   }
}

    const clickEmail = (email, sel) => {


        let data = telPhone ?
            { "country": en[parsePhoneNumber(telPhone).country],
            "abrCountry": parsePhoneNumber(telPhone).country,
            "ariaCode": getCountryCallingCode(parsePhoneNumber(telPhone).country) ,
            "National": formatPhoneNumber(telPhone),
            "International": formatPhoneNumberIntl(telPhone)
            }:
            { "country": '',
            "abrCountry": '',
            "ariaCode": '' ,
            "National": '',
            "International": ''
            }
             UserByMail(token, email, data, emailvsTelAdding, Family()).then(data => {

            if (data.error) {
                setURole({ ...Urole, class_ErrName: data.class_name ? data.class_name: 'alert alert-danger', error: data.error, emailExit: data.emailExit, passwordShow: data.password});
            } else {
                if (betterRole(data.user.userActiveRole.roleName,  sel)){

                    let d = parseFloat(nbrDays)
                    let expirationday =  d && new Date().getTime() + d * 24 * 3600 * 1000
                    let final =    d &&  Math.abs(expirationday - new Date())
                     setNbrTimer(final)

                editroleuser =  editRole(data.user.userActiveRole.roleName,  sel);
               let messageUser  =  `L’utilisateur à ajouter possède dejà un compte ${data.user.userActiveRole.roleName}. Souhaitez-vous modifier ses capacites d’ajout d’utilisateurs dans ses equipes ? Vous pouvez augmenter ou diminuer ces capacites. Veuillez selectionner votre choix.`;
               // Always window.location.origin (never ELAKAY_URl/a hardcoded
               // host) for the activation link itself.
               const origin = typeof window !== "undefined" ? window.location.origin : "";

               // data.user.ativator is never present here (User.toJSON() strips
               // it) — the real token, if this existing user already has a
               // pending invite, is fetched on demand via the narrow
               // getUserAddingRoleToken endpoint. Never build a link with
               // "undefined": buildUserChoosingUrl() returns "" when nothing
               // usable was found.
               if (!data.emailExit) {
                   getUserAddingRoleToken(token, data.user._id).then((tokenData) => {
                       const url = buildUserChoosingUrl(tokenData?.token)
                       setTokenua(!!url)
                       setShareUrl(url || `${origin}/your-step/?us=${data.user.userActiveRole.roleName}`)
                   })
               } else {
                   setTokenua(false)
                   setShareUrl(`${origin}/your-step/?us=${data.user.userActiveRole.roleName}`)
               }

            setURole({
                ...Urole,
                userID: data.user._id,
                firstname: data.user.firstname,
                lastname: data.user.lastname,
                email: data.user.email,
                customer: data.user.userActiveRole.customer,
                seller: data.user.userActiveRole.seller,
                provider: data.user.userActiveRole.provider,
                userRole:data.user.userActiveRole.roleName,
                maxRoyalite: data.user.userActiveRole.maxRoyalite,
                maxSeller:data.user.userActiveRole.maxSeller,
                maxProducer: data.user.userActiveRole.maxProducer,
                maxAssociate:data.user.userActiveRole.maxAssociate,
                maxInvestment: data.user.userActiveRole.maxInvestment,
                maxAdmin: data.user.userActiveRole.maxAdmin,
                message: editroleuser ? messageUser: data.massage,
                passwordShow: true ,
                emailExit: data.emailExit
            })
            }else{
                setURole({ ...Urole, error: __elakayText("t004", "sorry elakay have something better for this user") });
            }

        }
        })
    }
    const clickPassword = (roleI, Rele_user, roleName) => {
        let userIn = {firstname, lastname, role: Rele_user, emailUser, roleName, maxRoyalite: maxRoyalite, maxSeller: maxSeller, maxProducer: maxProducer, maxAdmin: maxAdmin}
        // customer/seller/provider are always derived fresh from the roleName
        // just selected -- never from the destructured Urole.customer/
        // seller/provider state, which is stale leftover from clickEmail's
        // lookup of a *previously existing* account and meaningless for a
        // brand new one (clickEmail's "user not found" branch returns
        // userActiveRole: {}, so seller/provider are always undefined there
        // regardless of the role being assigned). maxInvestment/maxAdmin
        // were also previously swapped here -- each must land on the state
        // field with the matching name, never its counterpart.
        let roleUs = { customer: roleName === 'Royalty', seller: roleName === 'Seller', provider: roleName === 'Provider', userid: userID, role: Rele_user, [roleName]: true, roleName, level: roleI, maxRoyalite: Number(maxRoyalite), maxSeller: Number(maxSeller), maxProducer: Number(maxProducer), maxAssociate: Number(maxAssociate), maxInvestment: Number(maxInvestment), maxAdmin: Number(maxAdmin)}
        let myInfo = {userAdmin: infoSource.userInfo._id, password, nbrDays}

        let userTel = telPhone ?
        { "country": en[parsePhoneNumber(telPhone).country],
        "abrCountry": parsePhoneNumber(telPhone).country,
        "ariaCode": getCountryCallingCode(parsePhoneNumber(telPhone).country) ,
        "National": formatPhoneNumber(telPhone),
        "International": formatPhoneNumberIntl(telPhone)
        }:
        { "country": '',
        "abrCountry": '',
        "ariaCode": '' ,
        "National": '',
        "International": ''
        }

        setOperationStatus("submitting")
        UpdateUserRoleByAdmin(token, userIn, roleUs, myInfo, userTel, emailExit, emailvsTelAdding).then(data => {
            if (data.error) {
                setOperationStatus("idle")
                setURole({ ...Urole, class_ErrName: data.class_name, error: data.error });
            } else {
                // Single source of truth for the result (mission 13): never
                // rebuilt from several older, possibly-desynchronized
                // variables. activation.shareUrl is already fully built
                // server-side (User.ativator[].token, never the whole array,
                // never the admin's own JWT).
                setOperationResult(data)
                setActivationUrl(toElakaySiteUrl(data?.activation?.shareUrl || ""))
                setOperationStatus("success")
            }
        })


    }

    const clickCancel = () => {
        setSelectRole(0)
        setURole(objUserRole)

    }

    // Single shared share implementation across the whole app (same
    // component as ShopUser's header / ProductPreview / CardUser's
    // activation modal) — never a second, forked share UI.
    const shareUser =()=>{
        return <div style={{ marginTop: 16 }}>
         <ShareButton
         infoSource={infoSource}
         url={shareUrl}
         title={getShareMessageByLang(infoSource.languageAPI.language)}
         showCopyButton
         disabled={!shareUrl}
         />
             </div>

     }


    const showSuccess = () => !success ? null : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: "12px 16px", background: D.greenLt, borderRadius: 10, border: "1px solid #86efac", marginBottom: 14 }}>
            <span style={{ fontSize: 13, color: "#065f46", fontWeight: 500 }}>{success}</span>
            {tokenua && shareUser()}
        </div>
    );


    const actionButton = (label, onClick, enabled, variant = "primary") => (
        <button
          type="button"
          onClick={enabled ? onClick : undefined}
          disabled={!enabled}
          className={`btn ${variant === "secondary" ? "btn-outline-primary" : "btn-primary"}`}
        >
          {label}
        </button>
    );

    const telephoneuser =(roleI)=>(
        <div>
            { formTimer()}
            <label className="invitation-label" htmlFor="invitation-phone">{infoSource.laguangeElakay("label", infoSource.languageAPI).enterPhoneNumber}</label>
            <PhoneInput id="invitation-phone"
                countrySelectProps={{ unicodeFlags: true }}
                defaultCountry="US"
                placeholder={infoSource.laguangeElakay('label', infoSource.languageAPI).enterPhoneNumber}
                value={telPhone}
                onChange={setTelPhone}
                error={telPhone ? (isValidPhoneNumber(telPhone) ? undefined : 'Invalid phone number') : 'Phone number required'}
            />
            {
                !passwordShow && (
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                    {actionButton(InfoApiButton.check, () => (clickEmail(emailUser, roleI)), telPhone && isValidPhoneNumber(telPhone) && nbrDays > 0)}
                  </div>
                )}
        </div>
        )

    const formSelect = () => (
        !passwordShow && (
            <div className="admin-card invitation-choice">
                <label className="invitation-label" htmlFor="invitation-role">{tt("targetRole")}</label>
                <select id="invitation-role" onChange={handleChange()} value={selectRole} className="invitation-input">
                    <option value="0">{InfoApiLabel.pleaseSelect}</option>
                    {Assoociate() && (
                        <>
                    <option value="1">{InfoApiLabel.addUserRoyalty}</option>
                    <option value="2">{InfoApiMenuSertting.addSeller}</option>
                    <option value="3">{InfoApiMenuSertting.addProducer}</option>
                    </>
                    )}
                     {Investment() && (
                        <>
                    <option value="4">{InfoApiMenuSertting.addAssociate}</option>
                    </>)}
                    {Adminstrator() && (
                    <>
                    <option value="5">{InfoApiMenuSertting.addInvestment}</option>
                    </>)}
                    {Family() && (
                    <>
                    <option value="6">{InfoApiMenuSertting.addAdministrator}</option>
                    <option value="7">{InfoApiMenuSertting.addFamilly}</option>
                    </>
                    )}
                </select>
                {btnAddEdit()}
                {showSuccess()}
            </div>
        ))

    const formTimer = ()=>(
        <div className="invitation-expiration">
            {!passwordShow && (
              <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 4 }}>
                <span style={{ fontSize: 24, fontWeight: 700, color: D.txt1 }}>{nbrDays}</span>
                <span style={{ fontSize: 12, color: D.txt2 }}>{__elakayText("t003", "days for expiration")}</span>
              </div>
            )}
            <label className="invitation-label" htmlFor="invitation-duration">{infoSource.language(infoSource, "label", "entDayexp")}</label>
            <input
                id="invitation-duration"
                onChange={handlePassword("nbrDays")}
                type="range"
                value={nbrDays > 0 ? nbrDays : 0}
                min="0"
                max="90"
                className="invitation-range"
            />
        </div>
    )
    const formEmail = (supRole, roleI) => (
        <div onBlur={() => setURole({ ...Urole, error: "" })}>
            {formTimer()}
            <label className="invitation-label" htmlFor="invitation-email">{InfoApiLabel.hisEmailaddress}</label>
            <input id="invitation-email" onChange={handleEmail("email")} type="email" className="invitation-input" placeholder={InfoApiLabel.emailWantAdd}/>
            <div style={{ fontSize: 11, color: D.txt3, marginTop: 4 }}>
               {InfoApiText.textAddAdminFamilly1}
            </div>
            {
                !passwordShow && (
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                    {actionButton(InfoApiButton.check, () => (clickEmail(emailUser, roleI)), emailUser != '' && nbrDays > 0)}
                  </div>
                )}
        </div>
    )

    const activeButton = ()=>{
        let a = maxRoyalite > 0 || maxRoyalite != ''
        let b = maxSeller > 0 || maxSeller != ''
        let c = maxProducer > 0 || maxProducer != ''
        let d = maxAssociate > 0 || maxAssociate != ''
        let e = maxInvestment > 0 || maxInvestment != ''
        let f = maxAdmin > 0  || maxAdmin != ''
        let g = nbrDays > 0 || nbrDays != ''
        let p = password != ''

        let g1Form = selectRole >= 4 && a && b && c && p && g
        let g2Form = selectRole >= 5 && g1Form && d
        let g3Form = selectRole >= 6 && g2Form  && e
        let g4Form = selectRole >= 7 &&   g3Form && f

         if(selectRole < 4){
            return p && g
        } else if(selectRole === 4){
            return g1Form
        } else if(selectRole === 5) {
            return g2Form
        } else if(selectRole === 6) {
            return g3Form
        }else if(selectRole === 7) {
            return g4Form
        }else{
            return false
        }
    }

    const alertCopy =()=> showAlert && (
           <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.greenLt, borderRadius: 8, border: "1px solid #86efac", marginBottom: 14 }}>
               <span style={{ fontSize: 12, color: "#065f46", fontWeight: 500 }}>{showAlert}</span>
             </div>
           )

    let assUserRole = infoSource.userRole

    const numberField = (label, name, value, max, fallbackLabel) => (
      <div>
        <label className="invitation-label" htmlFor={`invitation-${name}`}>{label}</label>
        <input
          id={`invitation-${name}`}
          onChange={handleChangeNumber(name)}
          type="number"
          max={max}
          placeholder={value > 0 ? value : fallbackLabel + ' ' + (Family() ? 'unlimited' : max)}
          value={value > 0 ? value : ''}
          className="invitation-input"
        />
      </div>
    );

    const formPassWord = (roleI, Rele_user, roleName) => (
        passwordShow && (
            <div onBlur={() => setURole({ ...Urole, error: "" })}>
                 {alertCopy()}

                 <div className="invitation-capacities">
                 {roleI >= 4 && (
                   <>
                     {numberField(InfoApiLabel.maxRoyality, "maxRoyalite", maxRoyalite, assUserRole.maxRoyalite, InfoApiLabel.maxUserRoyalitY)}
                     {numberField(InfoApiLabel.maxSeller, "maxSeller", maxSeller, assUserRole.maxSeller, InfoApiLabel.maxUserSeller)}
                     {numberField(InfoApiLabel.maxProducer, "maxProducer", maxProducer, assUserRole.maxProducer, InfoApiLabel.maxUserProducer)}
                   </>
                 )}

                 {roleI >= 5 && numberField(InfoApiLabel.maxAssoociate, "maxAssociate", maxAssociate, assUserRole.maxAssociate, InfoApiLabel.maxUserAssoociate)}

                 {roleI >= 6 && numberField(InfoApiLabel.maxInvestment, "maxInvestment", maxInvestment, assUserRole.maxInvestmen, InfoApiLabel.maxUserInvestment)}

                 {roleI >= 7 && numberField(InfoApiLabel.maxAdmin, "maxAdmin", maxAdmin, assUserRole.maxAdmin, InfoApiLabel.maxUserAdmin)}

                 </div>
                    <div style={{ borderTop: `1px solid ${D.border}`, margin: "18px 0" }} />

                    <label className="invitation-label" htmlFor="invitation-password">{InfoApiLabel.password || InfoApiLabel.Password}</label>
                    <input
                     id="invitation-password"
                     onChange={handlePassword("password")}
                     type="password"
                     className="invitation-input"
                     placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addAdminFamily.t002}
                     />
                    <div style={{ fontSize: 11, color: D.txt3, marginTop: 4 }}>
                      {InfoApiText.textAddAdminFamilly2}
                    </div>

                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
                  {actionButton(InfoApiButton.cancel, clickCancel, true, "secondary")}
                  {actionButton(InfoApiButton.submit, () => (clickPassword(roleI, Rele_user, roleName)), activeButton())}
                </div>
            </div>
        ))



    const formAddRole = (name, supRole, roleI, Rele_user, roleName) => (
        <div className="admin-card invitation-form">
            <div className="invitation-card-heading">
              <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 30, height: 30, borderRadius: 8, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
                <UserPlus size={15} />
              </span>
              <h4 style={{ fontSize: 14, fontWeight: 700, color: D.txt1, margin: 0 }}>{InfoApiButton.add} {name}</h4>
            </div>
                {showError()}
                {showMessage()}
                {showTime()}
                <div className="invitation-contact">{emailvsTelAdding ? formEmail(supRole, roleI): telephoneuser(roleI)}</div>
                {formPassWord(roleI, Rele_user, roleName)}
        </div>
    )


    let name
    let roleI
    let supRole
    let roleName
    let kay
    let shaObj

    const selectedUser = (selectRole) => (
        <div>
            {
               Assoociate() &&  selectRole === 1 && (

                    kay = sha1(roleUser[5].code) + sha1(roleUser[5].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "USER IN YOUR TEAM",
                    supRole = [2, 3, 4, 5],
                    roleName = "Royalty",

                    formAddRole(roleUser[5].role, supRole, 1, Rele_user, roleName)
                )
            }
            {
              Assoociate() && selectRole === 2 && (

                    kay = sha1(roleUser[4].code) + sha1(roleUser[4].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "SELLER",
                    roleI = 2,
                    supRole = [4, 5],
                    roleName = "Seller",
                    formAddRole(roleUser[4].role, supRole, roleI, Rele_user, roleName)
                )
            }
            {
               Assoociate() &&  selectRole === 3 && (
                    kay = sha1(roleUser[3].code) + sha1(roleUser[3].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "PROVIDER",
                    roleI = 3,
                    supRole = [4, 5],
                    roleName = "Provider",
                    formAddRole(roleUser[3].role, supRole, roleI, Rele_user, roleName)
                )
            }

            {
                Investment() &&  selectRole === 4 && (
                    kay = sha1(roleUser[6].code) + sha1(roleUser[6].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "ASSOCIATE",
                    roleI = 4,
                    supRole = 5,
                    roleName = "Associate",
                    formAddRole(roleUser[6].role, supRole, roleI, Rele_user, roleName)
                )
            }
            {
                Adminstrator() &&  selectRole === 5 && (
                    kay = sha1(roleUser[7].code) + sha1(roleUser[7].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "INVESTMENT",
                    roleI = 5,
                    supRole = 5,
                    roleName = "Investment",
                    formAddRole(roleUser[7].role, supRole, roleI, Rele_user, roleName)
                )
            }
            {
                Family() &&  selectRole === 6 && (
                    kay = sha1(roleUser[1].code) + sha1(roleUser[1].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "ADMINISTRATOR",
                    roleI = 6,
                    supRole = 5,
                    roleName = "Administrator",
                    formAddRole(roleUser[1].role, supRole, roleI, Rele_user, roleName)
                )
            }
            {
                Family() &&  selectRole === 7 && (
                    kay = sha1(roleUser[0].code) + sha1(roleUser[0].role) + sha1(userID),
                    shaObj = new jsSHA("SHA-512", "TEXT", {
                        hmacKey: { value: kay, format: "TEXT" },
                    }),
                    shaObj.update(kay),
                    Rele_user = shaObj.getHash("HEX"),

                    name = "FAMILY",
                    roleI = 7,
                    supRole = 5,
                    roleName = "Family",
                    formAddRole(roleUser[0].role, supRole, roleI, Rele_user, roleName)
                )
            }
        </div>
    )
    let clickEditAdd = ()=>{
        setEmailvsTelAdding(emailvsTelAdding? false : true)
        setEmailUser()
        setTelPhone()
     }

    const btnAddEdit =()=>(
        <div className="invitation-methods" role="group" aria-label={`${infoSource.language(infoSource, "label", "byEmail")} / ${infoSource.language(infoSource, "label", "byTelephon")}`}>
            <button type="button" className={emailvsTelAdding ? 'active' : ''} aria-pressed={emailvsTelAdding}
              onClick={emailvsTelAdding ? undefined : clickEditAdd}><Mail size={14} />{infoSource.language(infoSource, "label", "byEmail")}</button>
            <button type="button" className={!emailvsTelAdding ? 'active' : ''} aria-pressed={!emailvsTelAdding}
              onClick={emailvsTelAdding ? clickEditAdd : undefined}><Phone size={14} />{infoSource.language(infoSource, "label", "byTelephon")}</button>
        </div>
        )


    const showError = () => !error ? null : (
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 14 }}>
          <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
          <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{error}</span>
        </div>
    );
    const showMessage = () => !message ? null : (
     <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: "12px 16px", background: D.blueLt, borderRadius: 10, border: "1px solid #bfdbfe", marginBottom: 14 }}>
            <span style={{ fontSize: 13, color: D.txt1, fontWeight: 500 }}>{message}</span>
            {tokenua && shareUser()}
    </div>
    );
    // const redirectUser = () => {
    //    if (redirectToReferrer){
    //        return <Redirect to={`/u-w?us=${userID}&sel=${roleL}&pas=${passwordShow}`} />
    //     }
    // }

    // let images = [
    //     ElakayAccount,
    //     RoyaltyUser,
    //     SellerPub1
    // ]

    // const zoomOutProperties = {
    //     duration: 5000,
    //     transitionDuration: 500,
    //     infinite: true,
    //     indicators: false,
    //     scale: 0.4,
    //     arrows: true
    // }

    // let today =  new Date().getTime()
    // let expirationday =  new Date().getTime() + parseFloat(nbrDays) * 24 * 3600 * 1000
    // let nbrDayRestant = nbrDays > 0 ? Math.abs(new Date(nbrTimer) - new Date()) : 0
    // let nbrTimes =  parseFloat(nbrDays)

// let nbrDayRestant =  new Date(expirationday)
let d = parseFloat(nbrDays)
let expirationday =  d && new Date().getTime() + d * 24 * 3600 * 1000
    const showTime = ()=>{
        // setTimeout setInterval
        return passwordShow && nbrTimer > 0 && <Timer
                infoSource={infoSource}
                nbrdays = {nbrTimer}
                enDate={expirationday}
                />

    }

    return (
        <div className="invitation-workspace">
            {/* <GroupStatsTable groups={resultCompare} /> */}
            {infoSource.userRole && userTeam.groupedByRole &&  <AdminSlotTable objt={{groupedByRole: userTeam.groupedByRole, userRole: infoSource.userRole}} infoSource={infoSource} />}
            {operationStatus === "success" ? (
                // Never closes/clears itself (mission 12) -- stays up with
                // the three ActivationLinkActions until the admin clicks
                // Finish, which is the only thing that resets the form.
                <SuccessResultCard
                    infoSource={infoSource}
                    operationResult={operationResult}
                    activationUrl={activationUrl}
                    // mission 3: the existing invitation paragraph (already
                    // used by clickEmail/shareUser's preview flow below) --
                    // never replaced/duplicated, only the link is appended
                    // to it (done inside ActivationLinkActions).
                    shareMessage={getShareMessageByLang(infoSource.languageAPI.language)}
                    onFinish={handleFinishOperation}
                    onSuccess={(msg) => setShowAlert(msg)}
                    onError={(msg) => setURole((prev) => ({ ...prev, error: msg }))}
                />
            ) : (
                <>
                    {formSelect()}
                    {selectedUser(selectRole)}
                </>
            )}
            </div>
    );
};

export default Message;
